// extracted by mini-css-extract-plugin
export default {"cardContainer":"SelectRoleModal_cardContainer__TnSBo","card":"SelectRoleModal_card__Piper"};